module.exports = __webpack_public_path__ + "8e693de80e52c3b4adbe819621608d13.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/rabbit-in-hat-right-s.png
// module id = 2596
// module chunks = 0